import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as ScrollLink, scroller } from "react-scroll";
import { useNavigate, useLocation } from "react-router-dom";
import logotext from "../../../../assets/logo.png";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import logo1 from "../../../../assets/logo1.png";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { text: "Home", to: "/" },
    { text: "About Us", to: "/about" },
    { text: "Summer Camp", to: "/summer" },
    { text: "Courses", to: "/courses" },
    { text: "Achievements", to: "/achievements" },
    { text: "Facilities", to: "/facilities" },
    { text: "Blogs", to: "/articles" },
    { text: "Gallery", to: "/gallary" },
  ];

  // useEffect(() => {
  //   if (location.hash) {
  //     const section = location.hash.replace("#", "");
  //     scroller.scrollTo(section, { smooth: true, duration: 500 });
  //   }
  // }, [location]);

  const handleNavigation = (to) => {
    navigate(to)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Grid
      container
      sx={{
        padding: "5px 20px",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: "#fff",
        boxShadow: 5,
        "@media (max-width:600px)": { padding: "1px 10px" },
      }}
    >
      {/* Logo */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={logotext}
          alt="Logo"
          style={{ width: isMobile ? "250px" : "350px", height: "auto" }}
        />
      </Box>

      {/* Desktop Menu */}
      <Box
        sx={{
          gap: 1,
          display: "flex",
          "@media (max-width:600px)": { display: "none" },
        }}
      >
        {menuItems.map((item, index) => (
          <Button
            key={index}
            onClick={() => handleNavigation(item.to)}
            sx={{
              color: "black",
              backgroundColor: "#fff",
              fontWeight: "bold",
              ":hover": { color: "#1d67ab" },
            }}
          >
            {item.text}
          </Button>
        ))}
        <Button
          onClick={() => handleNavigation("/contact")}
          sx={{
            backgroundColor: "#1d67ab",
            color: "#fff",
            borderRadius: 10,
            fontWeight: "bold",
            px: 2,
            textTransform: "none",
          }}
        >
          Admission
        </Button>
      </Box>

      {/* Mobile Menu */}
      <Box sx={{ display: { xs: "flex", sm: "none" } }}>
        <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: "black" }}>
          <MenuIcon />
        </IconButton>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <Box sx={{ width: 300, mt: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", position: 'relative' }}>
              <img
                src={logo1}
                alt="Logo"
                style={{ width: isMobile ? "200px" : "400px", height: "auto" }}
              />
              <Box onClick={() => setDrawerOpen(false)} sx={{position: 'absolute', top: 10, right: 10, cursor: 'pointer' }}>
                <CloseIcon sx={{color: 'white', p: 1, backgroundColor: '#0169b0', borderRadius: 2,}} />
              </Box>
            </Box>
            <List>
            <Divider
              sx={{
                borderStyle: 'dashed',
                borderColor: '#ccc',
                mt: 0,
              }}
            />
              {menuItems.map((item, index) => (
                <React.Fragment key={index}>
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => {
                        handleNavigation(item.to);
                        setDrawerOpen(false);
                      }}
                      sx={{
                        px: 3, // padding left/right
                        py: 1.5,
                        '&:hover': { backgroundColor: '#f5f5f5' }, // subtle hover
                      }}
                    >
                      <ListItemText
                        primary={item.text}
                        primaryTypographyProps={{
                          fontWeight: 500,
                          color: '#0169b0', // theme color
                        }}
                      />
                    </ListItemButton>
                  </ListItem>

                  {/* Dashed separator */}
                  {index !== menuItems.length - 0 && (
                    <Divider
                      sx={{
                        borderStyle: 'dashed',
                        borderColor: '#ccc',
                        my: 0,
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </List>
          </Box>
        </Drawer>
      </Box>
    </Grid>
  );
};

export default Header;
